const pages = {
    disclaimer: {
        title: 'Disclaimer'
    },
    privacy: {
        title: 'Privacy Policy'
    },
    terms: {
        title: 'Terms of Use'
    }
}

export default pages
